"use strict";

import _Object$values from "babel-runtime/core-js/object/values";
import _Object$getPrototypeOf from "babel-runtime/core-js/object/get-prototype-of";
import _classCallCheck from "babel-runtime/helpers/classCallCheck";
import _createClass from "babel-runtime/helpers/createClass";
import _possibleConstructorReturn from "babel-runtime/helpers/possibleConstructorReturn";
import _inherits from "babel-runtime/helpers/inherits";
import Item from './Item';

var Question = function (_Item) {
    _inherits(Question, _Item);

    function Question(data) {
        _classCallCheck(this, Question);

        var _this = _possibleConstructorReturn(this, (Question.__proto__ || _Object$getPrototypeOf(Question)).call(this, data));

        if (_this.props) {
            var replyArray = _Object$values(_this.props);

            replyArray.sort(function (a, b) {
                return a.timestamp - b.timestamp;
            });
            _this.replies = replyArray;
        }
        return _this;
    }

    _createClass(Question, [{
        key: "merge",
        value: function merge(question) {
            if (!question) {
                return;
            }

            this.votes = question.votes === undefined ? this.votes : question.votes;
            this.voted = question.voted === undefined ? this.voted : question.voted;
            this.props = question.props === undefined ? this.props : question.props;
            this.replies = question.replies === undefined ? this.replies : question.replies;
        }
    }]);

    return Question;
}(Item);

export default Question;


//////////////////
// WEBPACK FOOTER
// ./submodules/dialogloop-sdk-js/dist/Items/Question.js
// module id = 181
// module chunks = 0